import { AppTypeTranslation, AppTypeTranslationEnum } from '@shared/core';

/*
$localize`:meaning|description@@id:source message text`;
 */

export const COFUS_GLOBOS_TRANSLATION_MAP: AppTypeTranslation = {
    [AppTypeTranslationEnum.TermsShort]: $localize`:Terms and conditions|Short version, shown initially@@terms.COFUS_GLOBOS.short:By agreeing to the terms and conditions, you acknowledge that you have read and understood the <strong>Cofus Globos</strong> agreement`,
    [AppTypeTranslationEnum.TermsLong]: $localize`:Terms and conditions|Long version, shown when expanded@@terms.COFUS_GLOBOS.long:I agree to the complete <strong>Cofus Globos</strong> terms...`,
    [AppTypeTranslationEnum.MedicalContactCenter]: $localize`:Contact|Medical contact center@@contact.COFUS_GLOBOS.medicalContactCenter:Medical Contact Center`,
};
